module.exports = __webpack_public_path__ + "static/media/step3.3110a9ed.png";